<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.9999 2.3999C6.6959 2.3999 2.3999 6.6959 2.3999 11.9999C2.3999 17.3039 6.6959 21.5999 11.9999
    21.5999C17.3039 21.5999 21.5999 17.3039 21.5999 11.9999C21.5999 6.6959 17.3039 2.3999 11.9999 2.3999ZM11.2619
    17.5919H9.6539L5.7659 12.1439L7.3751 10.6439L10.4579 13.5239L16.6271 6.4067L18.2351 7.5347L11.2619 17.5919Z"
          fill="#27AE60"/>
  </svg>

</template>

<script>
export default {
  name: "IconTimeControlFullSendCheck"
}
</script>

<style scoped>

</style>